export enum FrontPageImageType {
    Logo = 0,
    FirstImage = 1,
    SecondImage = 2,
    ThirdImage = 3,
}

export class FrontPageImage {
    public type?: FrontPageImageType;
    public url?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): FrontPageImage {
        const image: FrontPageImage = new FrontPageImage();

        image.type = this.type;
        image.url = this.url;

        return image;
    }
}
